import React from "react";
import style from "../../sass/project.module.scss";
import Span from "../../helper/Span";
import { ReactComponent as Qkart } from "../../helper/svgicon/Project/Qkart.svg";
import { ReactComponent as Weather } from "../../helper/svgicon/Project/Weather.svg";
import { ReactComponent as Qtrip } from "../../helper/svgicon/Project/Qtrip.svg";
import { ReactComponent as Portfolio } from "../../helper/svgicon/Project/Portfolio.svg";
import { ReactComponent as MyRoutine } from "../../helper/svgicon/Project/MyRoutine.svg";
import { FaEye, FaGithub } from "react-icons/fa";
import ProjectTechnologyIcons from "./ProjectTechnologyIcons";
const ProjectLayout = (props) => {
     return (
          <div className={style.project_layout}>
               <div className={style.project_layout_details}>
                    <div className={style.project_layout_details_tag}>{props.category}</div>
                    <div className={style.project_layout_details_name}>
                         <h2>{props.name}</h2>
                    </div>
                    <div className={style.project_layout_details_description}>
                         <p>{props.description}</p>
                    </div>
                    <div className={style.project_layout_details_technology}>
                         {props.technology.map((item, index) => (
                              <ProjectTechnologyIcons icon={item} key={index} />
                         ))}
                    </div>
                    <div className={style.project_layout_details_technology}>
                         <a href={props.github} target="_blank" rel="noopener noreferrer">
                              <FaGithub />
                         </a>
                         <a href={props.live} target="_blank" rel="noopener noreferrer">
                              <FaEye />
                         </a>
                    </div>
               </div>
               <div className={style.project_layout_image}>
                    <div className={style.project_layout_image_svg}>
                         {props.img === "qkart" && <Qkart />}
                         {props.img === "weather" && <Weather />}
                         {props.img === "qtrip" && <Qtrip />}
                         {props.img === "myroutine" && <MyRoutine />}
                         {props.img === "portfolio" && <Portfolio />}
                    </div>
               </div>
          </div>
     );
};
export default ProjectLayout;
